"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const utils_1 = require("../utils");
const OsmosysIcon_1 = require("../art/OsmosysIcon");
const react_if_1 = require("react-if");
const OsmosysAlert_1 = require("./OsmosysAlert");
exports.OsmosysUndesiredState = ({ message = 'Something went wrong!', description, level = 'warning', size = 'md', error, }) => {
    return (react_1.default.createElement(utils_1.OsmosysDiv, { osysName: "OsmosysUndesiredState.Outer", flexColCenteredFilled: true },
        react_1.default.createElement(utils_1.OsmosysDiv, { osysName: "OsmosysUndesiredState.Inner", flexRowCentered: true },
            react_1.default.createElement("div", { className: "text-center text-muted" },
                react_1.default.createElement("div", null,
                    react_1.default.createElement(OsmosysIcon_1.OsmosysIcon, { osysIcon: level === 'notFound'
                            ? 'notFound'
                            : level === 'info'
                                ? 'info'
                                : 'exclamation', iconStyle: level === 'info' ? 'light' : 'solid', size: size === 'lg' ? '2x' : 'lg' })),
                react_1.default.createElement(react_if_1.If, { condition: size === 'lg' },
                    react_1.default.createElement(react_if_1.Then, null,
                        react_1.default.createElement("h3", { className: "font-weight-light mb-0 mt-2" }, message)),
                    react_1.default.createElement(react_if_1.Else, null,
                        react_1.default.createElement("p", { className: "lead mb-0 mt-2" }, message))),
                react_1.default.createElement(react_if_1.When, { condition: !!description },
                    react_1.default.createElement("p", { className: utils_1.classnames('mb-0 mt-2', size === 'sm' && 'text-small small'
                        // size === 'lg'
                        ) }, description)))),
        react_1.default.createElement(react_if_1.If, { condition: !!error },
            react_1.default.createElement(react_if_1.Then, null,
                react_1.default.createElement(OsmosysAlert_1.OsmosysErrorAlert, { apolloError: error })))));
};
//# sourceMappingURL=OsmosysUndesiredState.js.map